/**
 * 마스터 졸업 컷신 큐.
 *
 * <p>2026-04-23 v2: 서/혼 Lv 5 달성 시 MasteryEvent 의 3-5 비트를 NarrativeBeatPlayer 로
 * 순차 재생. StoryFlash 단순 토스트 대신 서사 수준의 풀 컷신 경험.
 *
 * <p>App 루트에 MasteryCutsceneOverlay 하나만 마운트하고, 이 스토어에 queue 로 쌓아
 * 앞에서부터 재생.
 */

import { create } from "zustand";
import type { MasteryEvent } from "@/content/combatV2Content";

export interface MasteryCutsceneEntry {
    /** 이벤트 id (예: mastery.seo.seomgwang). */
    id: string;
    event: MasteryEvent;
    /** 경로 라벨 (예: "섬광의 서"). 이벤트 title 이 없을 때 폴백용. */
    pathLabel: string;
    /** "서" / "혼". */
    groupLabel: "서" | "혼";
}

interface MasteryCutsceneState {
    queue: MasteryCutsceneEntry[];
    push: (entry: MasteryCutsceneEntry) => void;
    shift: () => void;
    clear: () => void;
}

export const useMasteryCutscene = create<MasteryCutsceneState>((set) => ({
    queue: [],
    push: (entry) => set((s) => ({ queue: [...s.queue, entry] })),
    shift: () => set((s) => ({ queue: s.queue.slice(1) })),
    clear: () => set({ queue: [] }),
}));

/** 편의 — 컴포넌트 밖에서 push. */
export function pushMasteryCutscene(entry: MasteryCutsceneEntry) {
    useMasteryCutscene.getState().push(entry);
}
